import { Product } from "api/schema/productsSchema";
import React from "react";

import { GettingStartedSection } from "components/GettingStartedSection";

import styles from "./IntroductionContent.module.scss";
import ProductBanner from "./ProductBanner";

export interface IntroductionContentProps {
  products: Product[];
  userHasConnectedCompanies: boolean;
}

export const IntroductionContent = ({
  products,
  userHasConnectedCompanies,
}: IntroductionContentProps) => {
  if (products.length === 0) {
    return (
      <GettingStartedSection
        product={undefined}
        title="gettingStarted"
        displaySubtext={true}
      />
    );
  }

  const title = (() => {
    if (!userHasConnectedCompanies) {
      return "gettingStarted";
    }
    if (products.length === 1) {
      return "hide";
    }
    return "productName";
  })();

  return (
    <div className={styles.introductionContentWrapper}>
      {products.map((product) => (
        <div key={product.productId} className={styles.sectionWrapper}>
          {!userHasConnectedCompanies && (
            <ProductBanner productId={product.productId} />
          )}
          <GettingStartedSection
            product={product}
            displaySubtext={!userHasConnectedCompanies}
            title={title}
          />
        </div>
      ))}
    </div>
  );
};
